import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { UpdateCameraForm } from '@/features/camera'
import { useCameraItem } from '@/shared/api/cameras'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/cameras/update/$cameraId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { cameraId } = Route.useParams()
  const { data: cameraData } = useCameraItem({ id: cameraId })

  if (!cameraData?.camera) {
    return null
  }

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование камеры')}>
      <UpdateCameraForm onClose={close} camera={cameraData.camera} />
    </Offcanvas>
  )
}
